import $ from 'jquery';
import {getFullUrlPath} from './common';

let appConfig;
$.ajax(getFullUrlPath('NewIndex/GetAppConfig'), {
	async: false,
	cache: false,
	data:{TZone:(new Date().getTimezoneOffset() / 60 * -1)},
	success: data => (appConfig = data),
	error: console.error
});


export default { appConfig };
